import { Component, Input, OnInit } from '@angular/core';
import { HeaderComponent } from '@core-app/layout/header/header.component';

@Component({
    selector: 'core-brand-logo',
    template: `@if (isNotLink) {
            <div class="brand-logo">
                <ng-container *ngTemplateOutlet="logoWrapper"></ng-container>
            </div>
        } @else {
            <a
                [core-analytics]="{ action: 'Home', category: category || 'TOP-NAV' }"
                class="brand-logo"
                [ngClass]="additionalClasses"
                href="javascript:void(0)"
                aria-label="Navigate home"
                (click)="navigateToHome()"
            >
                <ng-container *ngTemplateOutlet="logoWrapper"></ng-container>
            </a>
        }
        <ng-template #logoWrapper>
            <div class="brand-logo__logo-wrapper">
                <img [alt]="getSiteName()" [ngSrc]="logoUrl | cdn" class="brand-logo__logo" fill priority />
            </div>
        </ng-template>`,
    standalone: false,
})
export class BrandLogoComponent extends HeaderComponent implements OnInit {
    @Input() category: string | null = null;
    @Input() isNotLink: boolean | null = null;
    @Input() additionalClasses: string | null = null;
}
